import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { AuthRouteTables, IPlayer } from "../../types/types";
import { GenericTableView } from "./GenericTableView";
import { PendingParticipantsView } from "./PendingParticipantsView";
import { TrafficView } from "./TrafficView";
import { playerAdminApi } from "./services/updateServices";

const StaffAdminView = lazy(() =>
  import("./views/StaffAdminView").then((module) => ({ default: module.StaffAdminView })),
);
const TeamsAdminView = lazy(() =>
  import("./views/TeamsAdminView").then((module) => ({ default: module.TeamsAdminView })),
);
const MatchesAdminView = lazy(() =>
  import("./views/MatchesAdminView").then((module) => ({ default: module.MatchesAdminView })),
);

const AdminTabFallback = () => (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "300px" }}>
    <CircularProgress />
  </Box>
);

const executeBulkDelete = async (
  ids: string[],
  deleteApiCall: (id: string) => Promise<unknown>,
): Promise<void> => {
  await Promise.all(ids.map((id) => deleteApiCall(id)));
};

export const renderAdminRoutes = () => {
  return (
    <>
      <Route
        path={AuthRouteTables.STAFF}
        element={
          <Suspense fallback={<AdminTabFallback />}>
            <StaffAdminView />
          </Suspense>
        }
      />
      <Route
        path={AuthRouteTables.MATCHES}
        element={
          <Suspense fallback={<AdminTabFallback />}>
            <MatchesAdminView />
          </Suspense>
        }
      />
      <Route
        path={AuthRouteTables.TEAMS}
        element={
          <Suspense fallback={<AdminTabFallback />}>
            <TeamsAdminView />
          </Suspense>
        }
      />
      <Route path={AuthRouteTables.PENDING} element={<PendingParticipantsView />} />
      <Route path={AuthRouteTables.TRAFFIC} element={<TrafficView />} />
      <Route
        path={AuthRouteTables.PLAYERS}
        element={
          <GenericTableView<IPlayer>
            onCreateSubmit={(item) => playerAdminApi.createPlayer(item as IPlayer)}
            onEdit={(item) => playerAdminApi.updatePlayer(item)}
            onDeleteConfirm={(ids) => executeBulkDelete(ids, playerAdminApi.deletePlayer)}
          />
        }
      />
    </>
  );
};
